import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";

// Custom layout
import MainLayout from "../../../../Layouts/Main";

// styles
import "./styles.scss";

// assets
import assets from "../../../../Assets";

//slice
import { fetchIndividualProduct } from "../../../../Redux/Slices/productCatalogSlice";

const ViewProductCatalog = () => {
  const { id, category_id, filter_id } = useParams()
  console.log(id, category_id, filter_id)
  const dispatch = useDispatch()
  const location = useLocation();
  const navigate = useNavigate()
  const search = location.state?.search || "";
  console.log(search, 'ooo')
  const [productData, setProductData] = useState(null);

  useEffect(() => {
    dispatch(
      fetchIndividualProduct({
        data:
          Number(category_id) === 1 ?
            { id, filter_id }
             :
            {
              id: id,
              category_id: category_id,
              filter_id: filter_id || false
            },
        callBack: fetchStaffCB,
      })
    )
  }, [id, category_id, filter_id])

  const fetchStaffCB = (data) => {
    console.log(data)
    setProductData(data.data)
  }



  return (
    <MainLayout pageName={"Product Catalog"}>
      <div className="goBackDiv" onClick={() => navigate(`/productCatalog`)}>
        <img src={assets.Icons.leftArrow} alt="backIcon" />
        <p>Back to Product Catalog</p>
      </div>
      <div className="product-details">
        <div className="view-product-details-header">
          <h2>{`${productData?.product_name} Details`}</h2>
        </div>

        <hr style={{ backgroundColor: "#E6E6E6" }} />
        <div className="detailsParentContainer">
          <div className="view-product-details-container">
            <h4>Product Details</h4>
            {productData ? (
              <>
                <div className="staff-basic-details-item"><div>Category</div><div>:&nbsp;&nbsp;{productData?.category_name ?? "-"}</div></div>
                {Number(category_id) !== 4 && Number(category_id) !== 1 &&
                  <>
                    <div className="staff-basic-details-item"><div>Sub Category</div><div>:&nbsp;&nbsp;{productData?.sub_category_name ?? "-"}</div></div>
                    <div className="staff-basic-details-item"><div>Type</div><div>:&nbsp;&nbsp;{productData?.filteration_type_name ?? "-"}</div></div>
                  </>
                }
                <div className="staff-basic-details-item"><div>Product Name</div><div>:&nbsp;&nbsp;{productData?.product_name ?? "-"}</div></div>
                {Number(category_id) !== 4 && Number(category_id) !== 1 &&
                  <>
                    <div className="staff-basic-details-item"><div>Product Brand</div><div>:&nbsp;&nbsp;{productData?.product_brand_name ?? "-"}</div></div>
                    <div className="staff-basic-details-item"><div>Product Sub Brand</div><div>:&nbsp;&nbsp;{productData?.product_sub_brand_name ?? "-"}</div></div>
                    <div className="staff-basic-details-item"><div>Cad Drawing </div><div>:&nbsp;&nbsp;{productData?.upload_cad_drawing ? <a href={productData?.upload_cad_drawing}>{productData?.upload_cad_drawing.split('---').pop()}</a> : "-"}</div></div>
                  </>
                }
                {Number(category_id) === 4 && Number(category_id) !== 1 &&
                  <>

                    <div className="staff-basic-details-item"><div>Gearbox Sizes</div><div>:&nbsp;&nbsp;{productData.gearbox_sizes?.join(", ") ?? "-"}</div></div>
                  </>
                }
              </>
            ) : ""}
          </div>
          <div className="view-product-details-container">
            <h4>More Details</h4>
            {productData ? (
              <>
                {Number(category_id) !== 4 && Number(category_id) !== 1 &&
                  <>
                    {Number(filter_id) === 1 ?
                      <>
                        <div className="staff-basic-details-item"><div>Baldwin</div><div>:&nbsp;&nbsp;{productData?.baldwin ?? "-"}</div></div>
                        <div className="staff-basic-details-item"><div>Fleetguard</div><div>:&nbsp;&nbsp;{productData?.fleetguard ?? "-"}</div></div>
                        <div className="staff-basic-details-item"><div>Hifi</div><div>:&nbsp;&nbsp;{productData?.hifi ?? "-"}</div></div>
                        <div className="staff-basic-details-item"><div>Sakura</div><div>:&nbsp;&nbsp;{productData?.sakura ?? "-"}</div></div>
                        <div className="staff-basic-details-item"><div>Donaldson</div><div>:&nbsp;&nbsp;{productData?.donaldson ?? "-"}</div></div>
                        <div className="staff-basic-details-item"><div>Hengst</div><div>:&nbsp;&nbsp;{productData?.hengst ?? "-"}</div></div>
                        <div className="staff-basic-details-item"><div>WIX</div><div>:&nbsp;&nbsp;{productData?.wix ?? "-"}</div></div>
                      </>
                      :
                      <>
                        <div className="staff-basic-details-item"><div>Max Flow Rate</div><div>:&nbsp;&nbsp;{productData?.max_flow_rate ?? "-"}</div></div>
                        <div className="staff-basic-details-item"><div>Working Pressure</div><div>:&nbsp;&nbsp;{productData?.working_pressure ?? "-"}</div></div>
                        <div className="staff-basic-details-item"><div>Rated Static Burst</div><div>:&nbsp;&nbsp;{productData?.rated_static_burst ?? "-"}</div></div>
                        <div className="staff-basic-details-item"><div>Max Viscosity</div><div>:&nbsp;&nbsp;{productData?.max_viscosity ?? "-"}</div></div>
                        <div className="staff-basic-details-item">
                          <div>Product Options</div>
                          <div>
                            :&nbsp;&nbsp;
                            {productData?.product_option?.length > 0
                              ? productData.product_option.map((opt, index) => (
                                <span key={index}>
                                  <strong>{opt.label}</strong>[{opt.value}]
                                  {index !== productData.product_option.length - 1 && ', '}
                                </span>
                              ))
                              : "-"}
                          </div>
                        </div>
                        <div className="staff-basic-details-item"><div>Mounting Connections</div><div>:&nbsp;&nbsp;{productData?.mounting_connection ?? "-"}</div></div>
                        <div className="staff-basic-details-item"><div>Housing Option Available</div><div>:&nbsp;&nbsp;{productData?.housing_option_available ?? "-"}</div></div>
                        <div className="staff-basic-details-item"><div>Description</div><div>:&nbsp;&nbsp;{productData?.description ?? "-"}</div></div>
                      </>
                    }
                  </>
                }
                {Number(category_id) === 4 &&
                  <>
                    <div className="staff-basic-details-item"><div>Torque Range</div><div>:&nbsp;&nbsp;{productData?.gearbox_torque_range ?? "-"}</div></div>
                    <div className="staff-basic-details-item"><div>Gearbox Ratios</div><div>:&nbsp;&nbsp;{productData?.gearbox_ratios ?? "-"}</div></div>
                    <div className="staff-basic-details-item"><div>Mechanical Rating</div><div>:&nbsp;&nbsp;{productData?.gearbox_mechanical_rating ?? "-"}</div></div>
                    <div className="staff-basic-details-item"><div>Input</div><div>:&nbsp;&nbsp;{productData?.gearbox_input ?? "-"}</div></div>
                    <div className="staff-basic-details-item"><div>Output</div><div>:&nbsp;&nbsp;{productData?.gearbox_output ?? "-"}</div></div>
                  </>
                }
                {
                  Number(category_id) === 1 &&
                  <>
                    <div className="staff-basic-details-item"><div>Designation</div><div>:&nbsp;&nbsp;{productData?.designation ?? "-"}</div></div>
                    <div className="staff-basic-details-item"><div>Features</div><div>:&nbsp;&nbsp;{productData?.features ?? "-"}</div></div>
                    <div className="staff-basic-details-item"><div>Suffix</div><div>:&nbsp;&nbsp;{productData?.suffix ?? "-"}</div></div>
                    <div className="staff-basic-details-item"><div>Performance Class</div><div>:&nbsp;&nbsp;{productData?.performance_class ?? "-"}</div></div>
                    <div className="staff-basic-details-item"><div>Bearing Type</div><div>:&nbsp;&nbsp;{productData?.bearing_type ?? "-"}</div></div>
                  </>
                }
              </>
            ) : ""}
          </div>
          {Number(category_id) === 1 &&
            <div className="view-product-details-container">
              {productData?.bearing_fields?.map((field, fieldIndex) => (
                <div key={fieldIndex}>
                  {/* Dimensions */}
                  {field.bearing_dimensions && field.bearing_dimensions.length > 1 && (
                    <div className="bearing-section">
                      <h4>Dimensions</h4>
                      {field.bearing_dimensions.slice(1).map((item, index) => (
                        <div className="staff-basic-details-item" key={index}>
                          <div>
                            {(() => {
                              switch (item.name) {
                                case "Radial Internal Clearance (µm)": return "Radial Internal Clearance";
                                case "Bore Size d (mm)": return "Bore Size(mm)";
                                case "Outside Diameter D (mm)": return "Outside Diameter(mm)";
                                case "Outside Ring Width B (mm)": return "Outside Ring Width(mm)";
                                case "Radius rs (min) (mm)": return "Radius";
                                default: return item.name;
                              }
                            })()}
                          </div>
                          <div>:&nbsp;&nbsp;{item.value ?? "-"}</div>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Load Ratings */}
                  {field.bearing_load_ratings && field.bearing_load_ratings.length > 1 && (
                    <div className="bearing-section">
                      <h4>Load Ratings</h4>
                      {field.bearing_load_ratings.slice(1).map((item, index) => (
                        <div className="staff-basic-details-item" key={index}>
                          <div>
                            {(() => {
                              switch (item.name) {
                                case "Dynamic Load Rating Cr (N)": return "Dynamic Load Rating";
                                case "Static Load Rating C0r (N)": return "Static Load Rating";
                                default: return item.name;
                              }
                            })()}
                          </div>
                          <div>:&nbsp;&nbsp;{item.value ?? "-"}</div>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Speed Ratings */}
                  {field.bearing_speed_ratings && field.bearing_speed_ratings.length > 1 && (
                    <div className="bearing-section">
                      <h4>Speed Ratings</h4>
                      {field.bearing_speed_ratings.slice(1).map((item, index) => (
                        <div className="staff-basic-details-item" key={index}>
                          <div>
                            {(() => {
                              switch (item.name) {
                                case "Reference Speed (rpm)": return "Reference Speed(rpm)";
                                case "Limiting Speed (rpm)": return "Limiting Speed(rpm)";
                                case "Mass (kg)": return "Mass(kg)";
                                default: return item.name;
                              }
                            })()}
                          </div>
                          <div>:&nbsp;&nbsp;{item.value ?? "-"}</div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          }

        </div>
        <div className="view-product-details-container">
          <h4>{productData?.product_catalog_images?.length > 1 ? "Product Images" : "Product Image"}</h4>
          {productData ? (
            <>
              <div className="product-image-container">
                {productData.product_catalog_images.length > 0 ? (
                  productData.product_catalog_images.map((item, index) => (
                    item.product_catalog_images ? (
                      <img key={index} src={item.product_catalog_images} alt="productImage" />
                    ) : (
                      <div key={index}>No image is found</div>
                    )
                  ))
                ) : (
                  <p>No images found</p> // This will be displayed if the array is empty
                )}
              </div>
            </>
          ) : ""}
        </div>

      </div>
    </MainLayout>
  );
};

export default ViewProductCatalog;
